<template>
  <d-modal
    size="lg"
    :class="{
      'big-popup': true,
      'is-hidden': isHidden,
      'dst-to-settle-popup': type === 'dst',
      'services-to-settle-popup': type === 'services'
    }"
    @close="handleClose">

    <d-modal-header class="px-4">
      <d-modal-title class="w-100">
        <div class="d-flex flex-wrap align-items-center">
          <span class="mr-2">
            {{ type === 'dst' ? 'Lista DST do rozliczenia' : 'Lista zdobień do rozliczenia' }}
          </span>

          <div class="ml-auto mr-3 d-flex">
            <d-button
              theme="primary"
              class="text-nowrap"
              @click.prevent="openImportPopup">
              <i class="material-icons">cloud_upload</i>
              Importuj XLSX
            </d-button>

            <d-button
              theme="success"
              class="ml-2 text-nowrap"
              :disabled="downloadInProgress"
              @click.prevent.stop="loadItemsData(true)">
              <div
                v-if="downloadInProgress"
                class="spinner-border spinner-border-sm mr-1"
                role="status">
              </div>
              <template v-else>
                <i class="material-icons">cloud_download</i>
              </template>
              Pobierz XLS
            </d-button>
          </div>
        </div>
      </d-modal-title>
    </d-modal-header>

    <d-modal-body class="px-4">
      <d-alert
        v-if="anyLoadError"
        show
        theme="warning"
        class="mb-4">
        Wczytywanie danych nie powiodło się.
        <a href="javascript:window.location.reload();" class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>

      <template v-else>
        <div
          v-if="!allDataLoaded"
          class="text-center py-5 text-primary">
          <div
            class="spinner-border spinner-border-sm mr-2 mt-1"
            role="status">
          </div>
          Trwa ładowanie danych&hellip;
        </div>

        <div v-else>
          <d-row style="width: 100%;" class="d-flex ml-0 mb-0 page-filters">
            <validation-observer
              ref="settlements-filters-form"
              tag="form"
              class="d-flex flex-wrap mb-3 w-100">

              <d-input
                v-if="type === 'services'"
                placeholder="Nazwa zamówienia"
                v-model="filters.orderName"
                class="mr-2 mb-2 flex-grow-1"
                style="width: auto;"/>

              <v-select
                style="min-width: 200px; max-width: 200px;"
                class="mr-2 mb-2 status-select"
                :options="orderSettlementOptions"
                v-model="filters.settlementStatus"
                :reduce="status => status.value"
                placeholder="Status rozliczenia"
                :searchable="false"
                label="label">
              </v-select>

              <v-select
                v-if="type === 'dst'"
                style="min-width: 200px;"
                class="mr-2 mb-2 status-select flex-grow-1"
                :options="allContractors"
                v-model="filters.contractorId"
                :reduce="item => item.id"
                placeholder="Wykonawca"
                :searchable="false"
                label="name">
              </v-select>

              <div class="mb-2 text-nowrap">
                <d-button
                  theme="info"
                  outline
                  class="mr-1"
                  @click.prevent="validateFiltersForm">
                  Szukaj
                </d-button>

                <d-button
                  theme="danger"
                  outline
                  @click.prevent="clearFilters">
                  Resetuj filtry
                </d-button>
              </div>
            </validation-observer>
          </d-row>

          <d-card style="width: 100%;">
            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0 align-middle text-center">ID</th>
                  <th scope="col" class="border-0 align-middle">Haft/Zamówienie</th>
                  <th scope="col" class="border-0 align-middle">DST</th>
                  <th scope="col" class="border-0 align-middle text-center">Ilość</th>
                  <th scope="col" class="border-0 align-middle text-center">Ściegi</th>
                  <th scope="col" class="border-0 align-middle text-center">Wysoki haft</th>
                  <th scope="col" class="border-0 align-middle text-center">Powtórne</th>
                  <th scope="col" class="border-0 align-middle text-center">Program</th>
                  <th scope="col" class="border-0 align-middle text-center text-lg-right">Ceny</th>
                  <th scope="col" class="border-0 align-middle text-center" style="width: 130px;">Akcje</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(service, index) of servicesList"
                  :key="'service-' + index">
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">ID</label>
                    {{ service.id }}
                  </td>
                  <td class="align-middle py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Haft/Zamówienie</label>
                    {{ service.name }}<br>
                    <small class="text-muted">{{ service.order_name }}</small>
                  </td>
                  <td class="align-middle py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">DST</label>
                    {{ service.dst_number || '-' }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Ilość</label>
                    {{ service.quantity }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Ściegi</label>
                    {{ service.stitch_number }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Wysoki haft</label>
                    {{ service.embroidery_over_55 ? 'Tak' : 'Nie' }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Powtórne</label>
                    {{ service.dst === 'REPEAT' ? 'T' : 'N' }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Program</label>
                    {{ service.price_setup }}
                  </td>
                  <td class="align-middle text-center text-lg-right py-lg-1 py-md-3 py-3">
                    <label class="table-mobile-label mb-1">Ceny</label>
                    <small>Haft: <strong>{{ service.price }}</strong></small><br>
                    <small>Wartość haftu: <strong>{{ service.item_value }}</strong></small><br>
                    <small class="text-primary">Wartość FV: <strong>{{ service.invoice_value }}</strong></small>
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <template v-if="type === 'services'">
                      <d-button
                        v-if="service.can_settlement"
                        theme="primary"
                        :disabled="settlementInProgress === service.id"
                        @click.native="settleItem(service.id)"
                        title="Rozlicz"
                        class="my-auto">
                        Rozlicz
                      </d-button>
                      <small v-else class="text-success">
                        <strong>Rozliczono:</strong><br>{{ service.settlement_at }}
                      </small>
                    </template>

                    <template v-if="type === 'dst'">
                      <d-button
                        v-if="service.can_dst_settlement"
                        theme="primary"
                        :disabled="settlementInProgress === service.id"
                        @click.native="settleItem(service.id)"
                        title="Rozlicz"
                        class="my-auto">
                        Rozlicz
                      </d-button>
                      <small v-else class="text-success">
                        <strong>Rozliczono:</strong><br>{{ service.dst_settlement_at }}
                      </small>
                    </template>
                  </td>
                </tr>
                <tr v-if="!servicesList.length">
                  <td colspan="10" class="text-center px-4 py-4">
                    Brak elementów do wyświetlenia&hellip;
                  </td>
                </tr>
              </tbody>
            </table>
          </d-card>

          <pagination :meta-data="paginationMetaData" class="mt-3" />
        </div>
      </template>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import debounce from 'lodash.debounce';
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'orders-settlements-popup',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data () {
    return {
      type: 'services', // 'services' || 'dst'
      isHidden: true,
      loaded: false,
      loadError: false,

      allContractors: [],
      loadedContractors: false,
      contractorsLoadError: false,

      downloadInProgress: false,
      settlementInProgress: false,
      servicesList: [],

      filters: {
        orderName: '',
        contractorId: '',
        settlementStatus: 'unsettled'
      },
      orderSettlementOptions: [
        { label: 'Nierozliczone', value: 'unsettled' },
        { label: 'Rozliczone', value: 'settled' },
        { label: 'Wszystkie', value: null }
      ]
    };
  },
  computed: {
    allDataLoaded () {
      if (this.type === 'dst') {
        return this.loaded && this.loadedContractors;
      }
      return this.loaded;
    },
    anyLoadError () {
      if (this.type === 'dst') {
        return this.loadError || this.contractorsLoadError;
      }
      return this.loadError;
    }
  },
  mounted () {
    this.$bus.$on('orders-services-to-settle-popup-show', () => this.openPopup('services'));
    this.$bus.$on('orders-services-to-settle-popup-reload', () => this.loadItemsData());

    this.$bus.$on('orders-dst-to-settle-popup-show', () => this.openPopup('dst'));
    this.$bus.$on('orders-dst-to-settle-popup-reload', () => this.loadItemsData());

    this.$bus.$on('pagination-page-changed', this.loadItemsData);
  },
  methods: {
    handleClose () {
      this.isHidden = true;
      this.loaded = false;
      this.loadedContractors = false;
    },
    openPopup (type) {
      this.type = type;
      this.currentPage = 1;
      this.clearFilters(false);

      this.loadItemsData();
      if (this.type === 'dst') {
        this.loadContractorsData();
      }

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    openImportPopup () {
      const eventName = this.type === 'dst'
        ? 'dashboard-dst-settlements-import-popup-open'
        : 'dashboard-services-settlements-import-popup-open';
      this.$bus.$emit(eventName);
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadItemsData();
    }, 250),
    loadItemsData (downloadAsFile = false) {
      this.loaded = false;
      this.loadError = false;

      let where = {};

      if (this.type === 'services') {
        if (this.filters.settlementStatus) {
          where.settlement_status = this.filters.settlementStatus;
        }
        if (this.filters.orderName) {
          where.order = { order_name: this.filters.orderName };
        }
      } else if (this.type === 'dst') {
        where.dst_settlement = 1;
        where.status = ['IN_REALIZATION', 'QUALITY_CONTROL', 'WAITING_ADDITIONAL_PRODUCTS', 'TO_SHIPMENT', 'ENDED'];

        if (this.filters.settlementStatus) {
          where.dst_settlement_status = this.filters.settlementStatus;
        }
        if (this.filters.contractorId) {
          where.contractor_id = this.filters.contractorId;
        }
      }

      if (downloadAsFile) {
        if (this.downloadInProgress) return;
        this.downloadInProgress = true;

        const payload = this.type === 'dst' ? { download_dst_excel: 1, where } : { download_excel: 1, where };
        const filename = this.type === 'dst' ? 'dst-do-rozliczenia.xlsx' : 'zdobienia-do-rozliczenia.xlsx';
        const selector = this.type === 'dst' ? '.dst-to-settle-popup .modal-body' : '.services-to-settle-popup .modal-body';

        this.$http.post('/api/orders/services/items', payload, { responseType: 'blob' })
          .then(response => {
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.querySelector(selector).appendChild(link);
              link.click();
              document.querySelector(selector).removeChild(link);
            } else {
              this.showDownloadError();
            }
            this.downloadInProgress = false;
            this.loaded = true;
          })
          .catch(error => {
            console.error(error);
            this.showDownloadError();
            this.downloadInProgress = false;
            this.loaded = true;
          });
      } else {
        ListUtils.loadItemsData(this, {
          method: 'get',
          endpoint: `/api/orders/services/items?page=${this.currentPage}`,
          listField: 'servicesList',
          pagination: true,
          params: { where }
        });
      }
    },
    loadContractorsData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/contractors/items',
        method: 'get',
        outputKey: 'allContractors',
        loadedKey: 'loadedContractors',
        errorKey: 'contractorsLoadError',
        params: { pagination: 0 }
      });
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['settlements-filters-form'], this.debouncedLoadFilteredData);
    },
    clearFilters (shouldReload = true) {
      this.filters = {
        orderName: '',
        contractorId: '',
        settlementStatus: 'unsettled'
      };

      if (shouldReload) {
        this.loadItemsData();
        this.$bus.$emit('view-filters-reset');
      }
    },
    settleItem (itemID) {
      this.settlementInProgress = itemID;
      const endpoint = this.type === 'dst'
        ? `/api/orders/services/dst-settlement/${itemID}`
        : `/api/orders/services/settlement/${itemID}`;

      const errorText = this.type === 'dst'
        ? 'Rozliczenie DST nie powiodło się. Spróbuj ponownie.'
        : 'Rozliczenie zdobienia nie powiodło się. Spróbuj ponownie.';

      const successText = this.type === 'dst'
        ? 'Wybrane DST zostało rozliczone'
        : 'Wybrane zdobienie zostało rozliczone';

      FormUtils.submitInBackground(this, {
        endpoint,
        errorTitle: 'Wystąpił błąd',
        errorText,
        successAction: () => {
          this.settlementInProgress = false;
          this.loadItemsData();

          Vue.swal({
            title: 'Rozliczenie dodane',
            html: successText,
            icon: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: 2000
          });
        },
        failAction: () => {
          this.settlementInProgress = false;
        }
      });
    },
    showDownloadError () {
      Vue.swal({
        title: 'Wystąpił błąd podczas pobierania',
        html: 'Spróbuj ponownie',
        icon: 'warning',
        confirmButtonText: 'OK',
        buttonsStyling: true
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('orders-services-to-settle-popup-show');
    this.$bus.$off('orders-services-to-settle-popup-reload');
    this.$bus.$off('orders-dst-to-settle-popup-show');
    this.$bus.$off('orders-dst-to-settle-popup-reload');
    this.$bus.$off('pagination-page-changed', this.loadItemsData);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
.modal-body {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}
</style>
